<template>
  <div class="otp-confirmation-popup">
    <popup :close-action="closePopup">
      <template v-slot:content>
        <enter-code
          :phone-number="phoneNumber"
          :confirm-code-action="onConfirm"
          :regenerate-code-action="onResend"
          :server-error="serverError"
          :reset-error="resetError"
          button-title="אישור ותשלום"
          :loading="loading" />
      </template>
    </popup>
  </div>
</template>

<script>
import BaseUI from '@riseupil/base-ui';
import EnterCode from '@/base-components/EnterCode.vue';

export default {
  name: 'OtpConfirmationPopup',
  components: {
    Popup: BaseUI.Popup,
    EnterCode,
  },
  props: {
    phoneNumber: {
      type: String,
      required: true,
    },
    confirmCode: {
      type: Function,
      required: true,
    },
    resendCode: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      serverError: '',
      loading: false,
    };
  },
  methods: {
    async onConfirm(code) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.serverError = '';
      try {
        await this.confirmCode(code);
        this.$emit('close');
      } catch (error) {
        if (error && error.message === 'invalid_otp') {
          this.serverError = 'INVALID_CODE';
        } else {
          this.$emit('close');
        }
      } finally {
        this.loading = false;
      }
    },
    async onResend(sendPlatform) {
      try {
        await this.resendCode(sendPlatform);
      } catch (error) {
        this.serverError = 'UNKNOWN_ERROR';
      }
    },
    resetError() {
      this.serverError = '';
    },
    closePopup() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.otp-confirmation-popup {
  direction: rtl;
  text-align: right;

  ::v-deep .wrong-number-link {
    display: none;
  }

  ::v-deep .otp-input {
    margin-top: 40px;
  }
}
</style>
